export const GET_PRESCRIPTION_COUNT = 'GET_PRESCRIPTION_COUNT';
export const GET_PRESCRIPTION_COUNT_SUCCESS = 'GET_PRESCRIPTION_COUNT_SUCCESS'
export const GET_PRESCRIPTION_COUNT_ERROR = 'GET_PRESCRIPTION_COUNT_ERROR'
